import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {EditeMember} from "../pages/EditeMember"
import {OtpVerify} from "../pages/Otp/OtpVerify"
import {Verifymobile} from "../pages/Otp/Verifymobile"
import {Confirmdata} from "../pages/Otp/Confirmdata"
import {Homepage} from "../pages/Homepage"
import {Contact} from "../pages/Contact"
import {Card} from "../pages/Card"
import {CreateMember} from "../pages/CreateMember"
import {Login} from "../pages/Login"
import {Consentpage} from "../pages/Consentpage"
import Coupon from '../pages/new-pages/coupon/Coupon';




const PrivateRoutes = () => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  //AVCDAAV.002  20/03/2025  Add code for adding page coupon
  // const Coupon = lazy(() => import('../pages/new-pages/coupon/Coupon'))
  const CouponDetail = lazy(() => import('../pages/new-pages/coupon/CouponDetail'))
  //C-AVCDAAV.002  20/03/2025  Add code for adding page coupon
  //AVCDAPNF.002  28/03/2025  Add code for ... Add ChangeMobilePhone page
  const ChangeMobilePhone = lazy(() => import('../pages/new-pages/ChangeMobilePhone'))
  //C-AVCDAPNF.002  28/03/2025  Add code for ... Add ChangeMobilePhone page

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}

          <Route path="/createMember" element={<CreateMember />} />
        <Route path="/editeMember" element={<EditeMember />} />
        <Route path="/otpVerify" element={<OtpVerify />} />
          <Route path="/verifymobile" element={<Verifymobile />} />
          {/* //AVCDAAV.002  20/03/2025  Add code for adding route for coupon */}
          <Route path="/coupon" element={<Coupon />}/>
          <Route path="/coupon/:couponId" element={<CouponDetail />} />
          {/* //C-AVCDAAV.002  20/03/2025  Add code for adding route for coupon */}
          {/* //AVCDAPNF.002  28/03/2025  Add code for ... Add ChangeMobilePhone page */}
          <Route path="/change-mobile-phone" element={<ChangeMobilePhone />} />
          {/* //C-AVCDAPNF.002  28/03/2025  Add code for ... Add ChangeMobilePhone page */}

          <Route path="/consentpage" element={<Consentpage />} />
          <Route path="/verifymobile/culb2" element={<Verifymobile />} />
            <Route path="/confirmdata" element={<Confirmdata />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/card" element={<Card />} />
            <Route path="/login" element={<Login />} />

        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
